import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 24px 16px;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 48px;
  }
`;

export const NavigationBar = styled.div`
  display: flex;
  align-items: center;
`;
export const GoBackNavWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-right: auto;
  cursor: pointer;
  > svg {
    width: 24px;
    height: 24px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    gap: 24px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    gap: 40px;
  }
`;
export const PropertyTitle = styled.h6`
  font-family: "Inter", sans-serif;
  font-weight: 700;
  color: #0f1015;
  font-size: ${16 / 16}rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${20 / 16}rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    font-size: ${24 / 16}rem;
  }
`;
export const ShareWrapper = styled.a`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.palette.greyscale.grey800};
  > p {
    font-family: "Inter", sans-serif;
    display: none;
    font-weight: 500;
    font-size: ${20 / 16}rem;
    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
      display: unset;
    }
  }
  > svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  cursor: pointer;
`;

export const MasonryWrapper = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 8px;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 48px;
    grid-template-columns: repeat(4, 1fr);
  }
`;
export const MasonryItem = styled.div`
  line-height: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const MasonryImg = styled.img`
  width: 100%;
  cursor: pointer;
`;
export const AIBadge = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  background: #3f4043;
  color: white;
  font-size: 12px;
  font-weight: 600;
  padding: 12px 8px;
  border-radius: 6px;
  backdrop-filter: blur(4px);
`;
export const MasonryImgWrapper = styled.div`
  position: relative;
  cursor: pointer;
`;
